import dynamicFrom from './dynamicFrom.vue'
export default dynamicFrom
